<template>
  <article class="Parent">
    <div class="Content-Wrapper">
      <Title
        :v-style="{ fontFamily: 'Foco', textAlign: 'center' }"
        color="white"
        >{{ $t('voice_assistant.header') }}</Title
      >
      <div class="Description mt-2">
        {{ $t('voice_assistant.description') }}
      </div>
      <Space :pheight="spacing.top" />
      <div class="SvgWrapper">
        <voice-mobile v-if="isMobile" />
        <voice-desktop v-else />
      </div>
      <Space :pheight="spacing.bottom" />
      <HStack
        :pstyle="{
          justifyContent: 'center',
          width: isMobile ? '100%' : '90%',
          alignItems: 'center',
          flexWrap: 'wrap',
        }"
      >
        <div class="text-qwraysuperlight-100 Try">
          {{ $t('voice_assistant.try_commands') }}
        </div>
        <div class="bg-qwraylight py-2 px-4 shadow-md rounded-full VoiceChip">
          {{ $t('voice_assistant.command1') }}
        </div>
        <div class="bg-qwraylight py-2 px-4 shadow-md rounded-full VoiceChip">
          {{ $t('voice_assistant.command2') }}
        </div>
        <div
          class="bg-qwraylight py-2 px-4 shadow-md rounded-full shadow VoiceChip"
        >
          {{ $t('voice_assistant.command3') }}
        </div>
      </HStack>
      <Space pheight="50px" />
    </div>
  </article>
</template>
<script>
import VoiceMobile from '../icons/ExperiencePage/VoiceMobile.vue';
import VoiceDesktop from '../icons/ExperiencePage/VoiceDesktop.vue';
import { HStack } from '../../layout/flexbox';
import Title from './Title.vue';
import Space from '../../layout/space';

export default {
  components: {
    VoiceMobile,
    VoiceDesktop,
    HStack,
    Space,
    Title,
  },
  data() {
    return {
      isMobile: true,
      spacing: { top: '28px', bottom: '90px', large: false },
    };
  },
  created() {
    this.onResize();
  },
  methods: {
    onResize() {
      if (window.innerWidth <= 768 && !this.isMobile) {
        this.isMobile = true;
      } else if (window.innerWidth > 768 && this.isMobile) {
        this.isMobile = false;
      }
      // change spacing for large and medium-to-small screen sizes
      if (window.innerWidth >= 1400 && !this.spacing.large) {
        this.spacing = { large: true, top: '0px', bottom: '40px' };
      } else if (window.innerWidth < 1400 && this.spacing.large) {
        this.spacing = { large: false, top: '28px', bottom: '90px' };
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
};
</script>
<style scoped>
.Parent {
  --svg-width: 100%;
  --svg-max-width: auto;
  --des-f-size: 14px;
  --des-margin-top: 40px;
  --des-margin-bottom: 45px;
  --parent-height: 580px;
  --try-width: 100%;
  --try-m-bottom: 1em;
  --try-f-size: 14px;
  --voice-f-size: 12px;
  --description-max-size: 80%;
  --content-wrapper-max-size: max-content;
  --content-wrapper-width: auto;
  background: url(~@/assets/experiencePage/Voice-BG-img.jpg);
  background-size: cover;
  background-position: center center;
  min-height: var(--parent-height);
  display: flex;
  justify-content: center;
  align-items: center;
}
.SvgWrapper {
  width: var(--svg-width);
  /* max-width: var(--svg-max-width); */
}
.Voice-Title {
  font-size: 70px;
}
.Content-Wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: bold;
  color: white;
  max-width: var(--content-wrapper-max-size);
  margin-top: 3em;
  width: var(--content-wrapper-width);
}
.Description {
  margin-top: var(--des-margin-top);
  margin-bottom: var(--des-margin-bottom);
  max-width: var(--description-max-size);
  font-size: var(--des-f-size);
  font-weight: normal;
}
.Try {
  font-weight: normal;
  font-size: var(--try-f-size);
  width: var(--try-width);
  margin-bottom: var(--try-m-bottom);
  text-align: center;
}
.VoiceChip {
  font-size: var(--voice-f-size);
  font-weight: normal;
  margin: 0.5em 1em;
}
@media (min-width: 768px) {
  .Parent {
    --svg-width: 100%;
    --svg-max-width: 720px;
    --des-margin: 0.5em;
    --parent-height: 520px;
    --try-width: auto;
    --try-m-bottom: 0;
    --try-f-size: 9px;
    --voice-f-size: 9px;
    --description-max-size: 500px;
    --content-wrapper-width: 100%;
    --content-wrapper-max-size: none;
  }
}
@media (min-width: 1024px) {
  .Parent {
    --description-max-size: 60%;
    --try-f-size: 14px;
    --voice-f-size: 14px;
    --content-wrapper-max-size: 100%;
    --svg-width: 100%;
  }
}

@media (min-width: 1400px) {
  .Parent {
    --des-f-size: 18px;
    height: 520px;
  }
}
@media (min-width: 1600px) {
  .Parent {
    --des-f-size: 20px;
  }
}
</style>
